<template>
 <OnClickOutside :key="team.id" :do="closeOutside" v-if="renderComponent">
  <div @click="handleAvatar" :class="show ? 'w-20 h-20' : 'w-10 h-10' " class="bg-gray border-additional-text border-1 rounded-full  md:w-20 md:h-20  flex flex-row items-center justify-center relative avatar" >
    <div class="relative" v-if="spinner">
      <div v-if="spinner"  :class="[show ? 'w-10 h-10' : 'w-5 h-5 md:w-10 md:h-10', newTeamAvatar ? 'w-20 h-20' : '' ]" class="preview avatar-pic relative bg-gray"/>
      <img v-if="spinner" class="absolute spinner" src="../../../assets/spinners/tail-spin.svg">
    </div>
    <div class="relative" v-else>
        <input ref="file" class="input-hide" @change="handleLoading" type="file" accept="image/*">
        <!-- Аватар-->
        <img ref="preview" v-if="!avatar"  :class="[show ? 'w-10 h-10' : 'w-5 h-5 md:w-10 md:h-10', newTeamAvatar ? 'w-20 h-20' : '' ]" class="preview avatar-pic relative" src="@/assets/emty-avatar.png"/>
        <img v-else :class="show ? 'w-20 h-20' : 'w-10 h-10' " class="avatar-pic md:w-20 md:h-20 relative" :src="avatar"/>
        <!-- Управляющие кнопки-->
        <img v-if="avatar && show" class="icon-edit  cursor-pointer" src="../../../assets/icons/edit.svg" alt="">
        <img v-else-if="show && !avatar && !newTeamAvatar" class="icon-edit-empty  cursor-pointer" src="../../../assets/icons/add.svg" alt="">
        <!-- Меню-->
        <div class="popper" v-if="show && popper">
              <p class="option">Изменить логотип команды
              <input ref="file" class="absolute cursor-pointer pin opacity-0 h-8" @change="uploadAvatar" type="file" accept="image/*">
              </p>
              <p @click="deleteAvatar" v-if="avatar" class="option">Удалить</p>
        </div>
    </div>
 </div>

  </OnClickOutside>
</template>
<script>
import players from '@/clients/player.js';
import OnClickOutside from '@/views/OnClickOutside';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      popper: false,
      newTeamAvatar: '',
      renderComponent: true,
      spinner: false,
    };
  },
  components: { OnClickOutside },
  props: ['show', 'teamId', 'avatar', 'newTeam', 'team'],
  methods: {
    ...mapActions(['refreshUser']),
    uploadAvatar(e) {
      const file = e.target.files[0];
      const data = new FormData();
      data.append('avatar', file);
      this.spinner = true;
      this.popper = false;
      players.post(`/teams/${this.team.id}/avatar`, data)
        .then((data) => {
          this.refreshAndClose();
        });
    },
    deleteAvatar() {
      this.spinner = true;
      players.delete(`/teams/${this.teamId}/avatar`).then((data) => {
        this.refreshAndClose();
        this.forceRerender();
      });
    },
    forceRerender() {
      /* почему-то реф с инпутом пропадает после удаления аватарки и этот костыль помогает фиксить проблему */
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    handleAvatar() {
      if (this.show) {
        this.avatar ? this.popper = true : this.$refs.file.click();
      }
    },
    handleLoading(e) {
      this.teamId ? this.uploadAvatar(e) : this.uploadNewTeam(e);
    },
    uploadNewTeam(e) {
      const self = this;
      const file = e.target.files[0];
      this.newTeamAvatar = file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        self.$refs.preview.src = reader.result;
      };
      this.$emit('saveNewTeamAvatar', file);
    },
    refreshAndClose() {
      this.refreshUser(players);
      this.popper = false;
    },
    closeOutside() {
      this.popper = false;
    },
  },
  watch: {
    avatar(newAvatar, oldAvatar) {
      if (newAvatar !== oldAvatar && this.spinner) this.spinner = false;
    },
  },
};
</script>
<style scoped>
.avatar-pic {
    object-fit:fill;
    border-radius: 50%;
    position: relative;
    top: 2px;
}
.option {
    width: 288px;
    background-color: white;
    z-index: 40;
    cursor: pointer;
    @apply pl-5 py-2;
}
.option:hover {
    @apply bg-brand-light text-white
}
.popper {
    position: absolute;
    top: 60px;
    right: -237px;
    border: 1px solid #DADADA;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.1);
    z-index: 70;
    border-radius: 5px;
}
.option:first-child {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
}
.option:last-child {
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}
.input-hide {
    position: fixed;
    top: -9999px;
    left: -9999px;
}
.icon-edit {
    position: absolute;
    bottom: 0;
    right: 0px;
    transition: transform .5s ease;
}
.icon-edit-empty {
    position: absolute;
    bottom: -24px;
    right: -24px;
    transition: transform .5s ease;
}
.icon-edit:hover {
    transform:translateY(-3px)
}
.icon-edit-empty:hover {
  transform:translateY(-3px)
}
.bg-gray {
    background-color: #dadada;
}
.spinner {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@media (max-width: 840px) {
    .popper {
        left: 0;
        z-index: 20;
    }
    .option {
    width: 100%;
}
}
</style>
